import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import { isEqual } from "lodash";
import {RootState } from "../../Core/Store";

interface mdcGroupingOption{
  unit:string;
  groupBy:string;
}

export interface alarmOptions{
    scopeOrder:string,
    machineTimesVisibility:boolean,
    alarmsVisibility:boolean,
    alarmChartSortOrder: "Count / Duration"| "Count / Duration per shift hours";
    machineTimesSortOrder:"Shift Length"|
    "Running Hours"|
    "Failure Hours"|
    "Failure Timeout"|
    "Idle after Running"|
    "Idle after Failure"|
    "Failure to running %"|
    "Failure to Shift %";
    chartItemNumber:number,
    machineHealthDrillDown:boolean,
    machineHealthGroupSize:"None"|"Day"|"Week"|"Month"|"Year",
    mdcDrillDown:boolean,
    mdcGroupSize:"None"|"Day"|"Week"|"Month"|"Year";
    mdcGroupingOptions: mdcGroupingOption[],
    cumuDataAs: string
}

const initialState: alarmOptions = {
    scopeOrder:"Customer > Machine",
    machineTimesVisibility:false,
    alarmsVisibility:false,
    alarmChartSortOrder:"Count / Duration",
    machineTimesSortOrder:"Shift Length",
    chartItemNumber:10,
    machineHealthDrillDown:false,
    machineHealthGroupSize:"None",
    mdcDrillDown:true,
    mdcGroupSize:"None",
    mdcGroupingOptions: [],
    cumuDataAs: "Raw"
};

const optionSlice = createSlice({
  name: "alarmOptions",
  initialState,
  reducers: {
    updateOptionsScopeOrder: (state, action: PayloadAction<string>) => {
        state.scopeOrder = action.payload
    },
    updateMachineTimesVisibility: (state,action:PayloadAction<boolean>)=>{
       
       state.machineTimesVisibility = action.payload
    },
    updateAlarmChartSortOrder(state,action:PayloadAction<alarmOptions['alarmChartSortOrder']>){
      state.alarmChartSortOrder = action.payload;
    },
    updateChartItemNumber(state,action:PayloadAction<number>){
      state.chartItemNumber = action.payload;
    },
    updateMachineTimesSortOrder(state,action:PayloadAction<alarmOptions['machineTimesSortOrder']>){
      state.machineTimesSortOrder = action.payload;
    },
    updateAlarmsVisibility: (state,action:PayloadAction<boolean>)=>{
       state.alarmsVisibility = action.payload
    },
    updateMachineHealthDrillDown:(state,action:PayloadAction<alarmOptions['machineHealthDrillDown']>)=>{
      state.machineHealthDrillDown = action.payload
    },
    updateMachineHealthGroupSize:(state,action:PayloadAction<alarmOptions['machineHealthGroupSize']>)=>{
      state.machineHealthGroupSize = action.payload
    },
    updateMdcDrillDown:(state,action:PayloadAction<alarmOptions['machineHealthDrillDown']>)=>{
      state.mdcDrillDown = action.payload
    },
    updateMdcGroupSize:(state,action:PayloadAction<alarmOptions['machineHealthGroupSize']>)=>{
      state.mdcGroupSize = action.payload
    },
    updateMdcGroupingOptions:(state,action)=>{
      state.mdcGroupingOptions = action.payload;
      },
      updateCumuDataAs: (state, action: PayloadAction<alarmOptions['cumuDataAs']>) => {
          state.cumuDataAs = action.payload;
      }
  }
});

export const { 
  updateOptionsScopeOrder,
  updateMachineTimesVisibility,
  updateAlarmChartSortOrder,
  updateChartItemNumber,
  updateMachineTimesSortOrder,
  updateAlarmsVisibility,
  updateMachineHealthDrillDown,
  updateMachineHealthGroupSize,
  updateMdcDrillDown,
  updateMdcGroupSize,
    updateMdcGroupingOptions,
    updateCumuDataAs } = optionSlice.actions;

export const getOptionsSelector = (state: RootState) => state.options;

export default optionSlice.reducer;